import axios from "./axios";

export async function fetchCaseGuideTemplates(params = {}) {
  return axios
    .get("/case_guides/templates", { params })
    .then((res) => res?.data?.data ?? [])
    .catch(() => []);
}

export async function fetchCaseGuideTemplate(id) {
  if (id == null || String(id).trim() === "") return null;
  return axios
    .get(`/case_guides/templates/${id}`)
    .then((res) => res?.data?.data ?? null)
    .catch(() => null);
}

export async function fetchActiveCaseGuideTemplate(caseTypeId, purpose = "onboarding") {
  if (!caseTypeId) return null;
  const templates = await fetchCaseGuideTemplates({
    case_type_id: caseTypeId,
    purpose,
  });
  return Array.isArray(templates) ? templates[0] ?? null : null;
}

export async function fetchActiveCaseGuideTemplates(caseTypeId, purpose = "onboarding") {
  if (!caseTypeId) return [];
  const rows = await fetchCaseGuideTemplates({
    case_type_id: caseTypeId,
    purpose,
  });
  if (!Array.isArray(rows)) return [];
  /** Type-specific templates first, then company-wide (`case_type_id: null`), same as report guides. */
  return [...rows].sort((a, b) => {
    const aw = a.case_type_id ? 0 : 1;
    const bw = b.case_type_id ? 0 : 1;
    if (aw !== bw) return aw - bw;
    return String(a.title || "").localeCompare(String(b.title || ""));
  });
}

export async function createCaseGuideTemplate(payload) {
  return axios
    .post("/case_guides/templates", { case_guide_template: payload })
    .then((res) => res?.data?.data ?? res?.data)
    .catch((err) => err?.response?.data);
}

export async function updateCaseGuideTemplate(id, payload) {
  return axios
    .put(`/case_guides/templates/${id}`, { case_guide_template: payload })
    .then((res) => res?.data?.data ?? res?.data)
    .catch((err) => err?.response?.data);
}

export async function createCaseGuideRun(caseId, payload, options = {}) {
  const params = {};
  if (options?.fields) params.fields = options.fields;

  return axios
    .post(`/cases/${caseId}/guide_runs`, { case_guide_run: payload }, { params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
}
